import styled from "styled-components";

export const ToggleThemeBox = styled.div`
  position: fixed;
  bottom: 30px;
  right: 30px;
  background-color: ${p => p.theme.colors.blue300};
  border-radius: 50%;
  overflow: hidden;

`;
